export { AppRoutingModule } from './app-routing.module';
